export const accessOptions = {
  DASHBOARD: 1,
  GENERATE_TICKETS: 2,
  VIRTUAL_TICKET: 9,
  PRESENTIAL_TICKET: 10,
  BOX: 6,
  ASSIGNMENT_BOX: 7,
  ATTENTION_BOX: 8,
  RESERVATION: 11,
  VIRTUAL_RESERVATION: 12,
};

export const platform = {
  GESCOL: 14,
};

export const attentionTypes = {
  PRESENTIAL: 1,
  VIRTUAL: 2,
};

export const ticketStatuses = {
  PENDING: 0,
  ATTENDING: 1,
  PAUSE: 2,
  FINALIZED: 3,
  REJECTED: 4,
  CALLING: 5,
};

export const priorityTypes = {
  CRITICAL_CUSTOMER: 1,
  RESERVATION: 2,
  PREFERENCE: 3,
  REGULAR: 4,
};
